import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOpen = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		children: [/* @__PURE__ */ _jsx("path", { d: "m2.03589 12.322c-.06901-.2074-.06901-.4316 0-.639 1.387-4.173 5.324-7.183 9.96401-7.183 4.638 0 8.573 3.007 9.963 7.178.07.207.07.431 0 .639-1.386 4.173-5.323 7.183-9.963 7.183-4.63801 0-8.57401-3.007-9.96401-7.178z" }), /* @__PURE__ */ _jsx("path", { d: "m15 12c0 .7956-.3161 1.5587-.8787 2.1213s-1.3257.8787-2.1213.8787-1.5587-.3161-2.12132-.8787c-.56261-.5626-.87868-1.3257-.87868-2.1213s.31607-1.5587.87868-2.12132c.56262-.56261 1.32572-.87868 2.12132-.87868s1.5587.31607 2.1213.87868c.5626.56262.8787 1.32572.8787 2.12132z" })]
	})
});
const ForwardRef = forwardRef(SvgOpen);
export default ForwardRef;
